import {isIde} from "../../../misc/envNameUtils.ts";
import {requestProjectFiles} from "../../../jsBridge/sender/ide/requestProjectFiles.ts";
import {getSettings} from "../userSettings/getSettings.ts";

export const checkEmbeddingInfoForProject = async (user: any, environmentObjRef: any, setEnvironmentObj: any, setDynamicStateObj: any, dynamicStateObjRef: any) => {
    const projectName = environmentObjRef.current.projectName;

    if (projectName === null) return;

    const userSettings = await getSettings(user, environmentObjRef.current.environment);
    let { codebaseEmbeddingsTracker } = userSettings;

    const projectEmbeddingsLastUpdated = projectName in codebaseEmbeddingsTracker ? codebaseEmbeddingsTracker[projectName]["lastUpdated"] : null;
    setEnvironmentObj({projectEmbeddingsLastUpdated: projectEmbeddingsLastUpdated});

    if (isIde(environmentObjRef.current.environment)) {
        // If no embeddings found, show popup to ask permission
        if (!projectEmbeddingsLastUpdated) {
            // Check if there's already a popup visible
            const currentPopup = dynamicStateObjRef?.current?.visiblePopup;

            if (currentPopup) {
                // If there's already a popup, wait for it to close before showing embeddings prompt
                const checkInterval = setInterval(() => {
                    if (!dynamicStateObjRef?.current?.visiblePopup) {
                        clearInterval(checkInterval);
                        setDynamicStateObj({ visiblePopup: 'noEmbeddingsPrompt' });
                    }
                }, 1000);
            } else {
                // No popup visible, show embeddings prompt immediately
                setDynamicStateObj({ visiblePopup: 'noEmbeddingsPrompt' });
            }
        } else {
            // If embeddings exist, proceed automatically
            requestProjectFiles(environmentObjRef.current.environment, environmentObjRef.current.vscode);
        }
    }
}